















































import { mapGetters } from 'vuex';

export default {
    name: 'JobDescription',

    data() {
        return {
            showJobDescriptionDialog: false,
            showDescription: false,
        };
    },

    props: {
        completed: {
            default: null,
            required: false,
            type: [Boolean, null],
        },
    },

    computed: {
        ...mapGetters('jobs/single', {
            job: 'getSingleJob',
        }),

        showMore() {
            return this.job.description?.length > 210;
        },

        jobHasExpired() {
            const today = new Date();
            const expiryDate = this.$dayjs(this.job?.expires);

            return expiryDate.diff(today, 'day') <= 0;
        },

        descriptionDocument() {
            return this.job.documents.find((document) => document.type === 'Job Specification') || null;
        },

        jobDescription() {
            return this.job.description?.replaceAll('<br>', '').replaceAll('</p>', '<br></p>') || null;
        },
    },

    methods: {
        edit() {
            this.$emit('edit');
            if (this.job.status !== 'Published') {
                this.redirectToDraft();
                return;
            }

            this.showJobDescriptionDialog = true;
        },

        redirectToDraft() {
            this.$emit('open-draft', 2, '#description');
        },

        async openDocument() {
            await this.$store
                .dispatch('documents/documents/getDocumentUrl', this.descriptionDocument.uuid)
                .then((res) => {
                    window.open(res.temporary_url, '_blank').focus();
                })
                .catch((error) => console.log(error));
        },
    },
};
